/**
 * Types compartilhados pelos componentes de configuração de nodes.
 */

import type { AvailableContext } from '@troia-v3/types';
import type { SavedVariable } from '../../utils/saved-variables';

export type { AvailableContext, SavedVariable };

export const EMPTY_CONTEXT: AvailableContext = {
  conversation: false,
  contact: false,
  lead: false,
  ticket: false,
  ai: false,
};

export interface NodeConfigProps {
  config: Record<string, unknown>;
  onChange: (config: Record<string, unknown>) => void;
  availableContext: AvailableContext;
  nodeId?: string;
  /**
   * Variáveis gravadas por nós anteriores (`saveAs`) — respostas das
   * Perguntas, número sequencial. Usado no mapeamento do "Salvar formulário".
   */
  savedVariables?: SavedVariable[];
  /**
   * "Perguntar formulário": perguntas que um "Salvar formulário" depois dele
   * preenche com outro valor (id do campo → nome do nó) — não são feitas.
   */
  filledLater?: Record<string, string>;
}
